import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComPhoto, DaumPost, Alert, Confirm } from '../../../js/ComponentManager'
import camera from '../../../img/camera.svg'
 

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class StoreInfo extends Component {
    static displayName = StoreInfo.name;
    constructor(props) {
        super(props);
        this.state = {
            Content: "",
            Title: "매장정보변경안내",
            Photo: "",
            Org_Name: "",
            Org_No: "",
            Org_No_Old: "",
            Depo_Name: "",
            Post_No: "",
            Addr_1: "",
            Addr_2: "",
            Org_File_Grp: "",
            Org_File_Name: "",
            Cng_Status:""
        };
        this.RegisterSuccess = false;
        this.handle_PhotoUpload = this.handle_PhotoUpload.bind(this);
        this.handlePost_Click = this.handlePost_Click.bind(this);
        this.handle_Change = this.handle_Change.bind(this);
        this.handle_BusinessFile = this.handle_BusinessFile.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSaveConfirm_Click = this.handleSaveConfirm_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handle_FileDownLoad = this.handle_FileDownLoad.bind(this);
        
    }

    //초기화
    componentDidMount() {
         
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            Big3Common.setContentStateBind(this);
        }
        else {
            this.DefaultData();
        }
        
    }
    //최초 매장정보 조회
    async DefaultData() {
        let Data = await Big3Common.Get("api/MyPage/MyInfoMgr/GetStoreInfo");
        if (Data.codeName === Big3Common.ResultCode.Success) {
            let StoreInfo = JSON.parse(Data.dataTable)[0];
            this.setState({
                Org_Name: StoreInfo.org_name || "",
                Org_No: StoreInfo.org_no || "",
                Org_No_Old: StoreInfo.org_no || "",
                Depo_Name: StoreInfo.depo_name || "",
                Post_No: StoreInfo.post_no || "",
                Addr_1: StoreInfo.addr_1 || "",
                Addr_2: StoreInfo.addr_2 || "",
                Org_File_Grp: StoreInfo.org_file_grp || "",
                Org_File_Name: StoreInfo.org_file_name || "",
                Cng_Status: StoreInfo.cng_status || "",
                Photo: StoreInfo.photo || "",
            });
        }

    }
    //매장사진 등록
    handle_PhotoUpload(event) {
        let StateCopy = this.state;
        Big3Common.BaseFileUpLoadConfig.FileType = Big3Common.WebConfig.UpLoadFileType.Image;
        Big3Common.BaseFileUpLoadConfig.UpLoadUrl = "api/MyPage/MyInfoMgr/PhotoUpLoad";
        Big3Common.BaseFileUpLoadConfig.RestUrl = "api/MyPage/MyInfoMgr/MyPhotoUpLoad";
        Big3Common.BaseFileUpLoadConfig.Blob = true;
        this.props.RenderComponent('PhotoUpload', StateCopy);
        event.preventDefault();
    }
    //사업자 등록증 업로드
    handle_BusinessFile(event) {
        let StateCopy = this.state;
        Big3Common.BaseFileUpLoadConfig.FileType = Big3Common.WebConfig.UpLoadFileType.File;
        Big3Common.BaseFileUpLoadConfig.UpLoadUrl = "api/Common/Common/FileUpLoad";
        Big3Common.BaseFileUpLoadConfig.RestUrl = "api/MyPage/MyInfoMgr/BusinessInfoFile";
        Big3Common.BaseFileUpLoadConfig.FileStoragePath = Big3Common.WebConfig.FileStoragePath.BusinessInfo;
        Big3Common.BaseFileUpLoadConfig.Blob = false;
        this.props.RenderComponent('BusinessInfo', StateCopy);
        event.preventDefault();
    }
    //우편번호 검색
    handlePost_Click(Zoneode, Address) {
        this.setState({ Post_No: Zoneode, Addr_1: Address });
        Big3Common.ModalClose(bootstrap, 'DaumPost');
        return false;
    }
    //값할당
    handle_Change(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();

        if (tagId === "Org_No") {

            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
            this.setState({ [tagId]: value });
        }
        else {
            this.setState({ [tagId]: value });
        }
        event.preventDefault();
    }
    //사업자번호 체크
    handleBlur(event) {
        let tagId = event.target.id;
        if (tagId === "Org_No" && this.state.Org_No !== "") {
            let isCheck = Big3Common.Util.OrgNumberCheck(this.state.Org_No);
            if (!isCheck) {
                this.setState({ Content: "사업자번호 형식이 잘못 되었습니다."});
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
                let Org_No = Big3Common.Util.OrgNumberFormat(this.state.Org_No);
                this.setState({ Org_No: Org_No });
            }
        }
        event.preventDefault();
    }
    //매장정보 수정 등록
    async handleSave_Click() {
        try {
            let Model = {
                Org_Name: this.state.Org_Name,
                Depo_Name: this.state.Depo_Name,
                Post_No: this.state.Post_No,
                Addr_1: this.state.Addr_1,
                Addr_2: this.state.Addr_2,
                Org_No: this.state.Org_No,                
                Org_File_Grp: this.state.Org_File_Grp === "" ? null : this.state.Org_File_Grp,
                Cng_Status: "01" //승인대기, MST_CODE:002
            };
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/RegisterOrgGrupreq', Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: "수정요청 완료", Content: "정보 수정 요청 후 관리자 승인 후 정보가 수정됩니다.(영업일 기준 3일 이내)" });
                this.RegisterSuccess = true;
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handleSave_Click: ", e)
        }
        return false;
    }
    handleSaveConfirm_Click() {
        let isOk = false;
        
        if (this.state.Org_Name.trim().length === 0) {
            this.setState({ Content: "매장명을 입력하여 주세요." });
        }
        else if (this.state.Depo_Name.trim().length === 0) {
            this.setState({ Content: "입금자명을 입력하여 주세요." });
        }
        else if (this.state.Post_No.trim().length === 0) {
            this.setState({ Content: "우편번호을 입력하여 주세요." });
        }
        else if (this.state.Addr_1.trim().length === 0) {
            this.setState({ Content: "매장 주소를 입력하여 주세요." });
        }
        else if (this.state.Addr_2.trim().length === 0) {
            this.setState({ Content: "매장 상세주소를 입력하여 주세요." });
        }
        else if (this.state.Org_No.trim().length === 0) {
            this.setState({ Content: "사업자등록번호를 입력하여 주세요." });
        }
        else if (!Big3Common.Util.OrgNumberCheck(this.state.Org_No)) {
            this.setState({ Content: "사업자번호 형식이 잘못 되었습니다." });
        }
        else if (this.state.Org_No !== this.state.Org_No_Old && Big3Common.WebStorage.GetSessionStorage(Big3Common.WebStorage.StorageName.FileGrpKey) === null) {
            this.setState({ Content: "사업자번호가 변경되면 사업자등록증을<br/> 다시 등록하셔야 합니다." });
        }
        else {
            isOk = true;
        }
        if (!isOk) {
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else {
            Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
        }
        return false;
    }
    //등록버튼 클릭 후 마이페이 이동
    handleMove_Click() {
        if (this.RegisterSuccess) {
            this.props.RenderComponent("MyPage");
        }
    }
    //사업자등록증 다운로드
    handle_FileDownLoad() {
        const file_grp = this.state.Org_File_Grp;
        const wrk_idx = Big3Common.WebConfig.FileDivision.BU;
        const fileName = this.state.Org_File_Name;
        let Url = `api/Common/Common/FileDownLoad/${file_grp}/${wrk_idx}`
        Big3Common.FileDownLoad(Url, fileName);

    }
    render() {
        return (
            <div>
                <div className="container_box p_b_margin c_padding">
                    <div className="store_img_box">
                        <div className="photo_box" onClick={this.handle_PhotoUpload}>
                            <ComPhoto
                                className="store_img"
                                Photo={this.state.Photo}
                            />
                            <div className="edit_photo"><img src={camera} alt='사진등록' /></div>
                        </div>
                        <div>매장사진</div>
                    </div>
                    <div className="input_line">
                        <label>매장명</label>
                        <input type="text"
                            id="Org_Name"
                            className="form-control"
                            maxLength="50"
                            value={this.state.Org_Name}
                            onChange={this.handle_Change || ""}
                        />
                    </div>
                    <div className="input_line">
                        <label>입금자명</label>
                        <input type="text"
                            id="Depo_Name"
                            className="form-control"
                            maxLength="20"
                            placeholder="사입자가 확인할수 있는 입금자"
                            value={this.state.Depo_Name || ""}
                            onChange={this.handle_Change}
                        />
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>매장 우편번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="Post_No"
                                className="form-control cn_input"
                                maxLength="5"
                                placeholder="우편번호를 입력하세요."
                                value={this.state.Post_No || ""}
                                readOnly
                            />
                            <button type="button" className="cn_button btn_v1" onClick={() => { Big3Common.ModalAlert(bootstrap, 'DaumPost'); }}>우편번호<br />검색</button>
                        </div>
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>매장 주소</label>
                        <input type="text"
                            id="Addr_1"
                            className="form-control"
                            maxLength="100"
                            placeholder="주소는 매장 우편번호 검색 후 자동입력됩니다."
                            value={this.state.Addr_1 || ""}
                            readOnly
                        />
                        <div className="input_txt"></div>
                    </div>
                    <div className="input_line">
                        <label>매장 상세주소</label>
                        <input type="text"
                            id="Addr_2"
                            className="form-control"
                            maxLength="50"
                            placeholder="상세주소를 입력해주세요."
                            value={this.state.Addr_2 || ""}
                            onChange={this.handle_Change}
                        />
                        <div className="input_txt"></div>
                    </div>
                    
                    <div className="input_line">
                        <label>사업자등록번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="Org_No"
                                className="form-control cn_input"
                                maxLength="12"
                                value={this.state.Org_No || ""}
                                onChange={this.handle_Change}
                                onBlur={this.handleBlur }
                            />
                           
                            <button type="button" className="cn_button btn_v1" onClick={this.handle_BusinessFile}>사업자등록증<br />첨부</button>
                        </div>
                        <div className="file_name_box"><div className="file_name" onClick={this.handle_FileDownLoad}>{this.state.Org_File_Name || ""}</div></div>
                    </div>
                    <div className="info_box">
                        <ul>
                            <li style={{ fontWeight: 'bold', color: '#F82020' }}>매장사진은 관리자 승인없이 등록 직후 적용됩니다.</li>
                            <li>사업자 정보 수정을 원하시는 경우, 먼저 해당  접수기관을 통해 사업자등록정보를 변경해야합니다. </li>
                            <li>변경된 사업자 정보 입력 및 사업자등록증을 재첨부 후, 정보수정 버튼을 클릭해주세요. </li>
                            <li>정보 수정 요청 후 관리자 승인 후 정보가 수정됩니다. (영업일 기준 3일 이내)</li>
                             
                        </ul>
                    </div>
                   
                    <div className="catagory_button_box">
                        {
                            this.state.Cng_Status === "03" ?
                                <button type="button" className="btn_v btn_v1" onClick={() => { this.handleSaveConfirm_Click() }}>정보수정</button> :
                                <button type="button" className="btn_v btn_inactive">관리자 검토중</button>
                        }
                    </div>
                   
                </div>
                <DaumPost
                    id="DaumPost"
                    PostClick={(Zoneode, Address) => this.handlePost_Click(Zoneode, Address)}
                />
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                    AlertClick={this.handleMove_Click}
                />
                <Confirm
                    id="ConfirmBox"
                    title="매장정보변경안내"
                    content="매장정보를 변경하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleSave_Click(e);
                    }}
                />
            </div>
            
        );
    }
}
